// @flow

/**
 * Module dependencies.
 */

import { Link } from 'react-router-dom';
import { colors, defaultTransition, media, states } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { getLocalizedUrl, isPhone } from 'client/core/utils';
import Icon from 'client/components/core/icon';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  color: string
};

/**
 * `LogoLink` component.
 */

const LogoLink = styled(Link)`
  display: inline-block;
  height: 33px;
  transition: ${defaultTransition};

  ${media.min.xs`
    height: 44px;
  `};

  ${states.action`
    color: ${({ color }): string => color};
  `}
`;

/**
 * `Logo` component.
 */

function Logo(props: Props): React$Element<*> {
  const { color } = props;
  const logoSize = isPhone() ? '108px' : '144px';

  return (
    <LogoLink
      color={color}
      to={getLocalizedUrl('home')}
    >
      <Icon
        icon={'logo'}
        size={logoSize}
      />
    </LogoLink>
  );
}

/**
 * Export `Logo`.
 */

export default compose(
  defaultProps({
    color: colors.white
  })
)(Logo);



// WEBPACK FOOTER //
// ../src/client/components/core/logo.js